package diana.soleil.design.iraniancanadienbazzar.feature.home

import androidx.compose.foundation.background
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.WindowInsets
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.statusBars
import androidx.compose.foundation.layout.statusBarsPadding
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.verticalScroll
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.onSizeChanged
import androidx.compose.ui.platform.LocalDensity
import androidx.compose.ui.graphics.Color
import androidx.compose.foundation.Image
import org.jetbrains.compose.resources.painterResource
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.GemArt
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.gemArtImage
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppIcon
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.NotificationBadge
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppSearchBar
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessCover
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.BusinessListItem
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppChip
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.CategoryTile
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.categoryImageRes
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.CityOption
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.CitySelector
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.CategoryTileSkeleton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EmptyState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ErrorState
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FeaturedBusinessCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.FeaturedCardSkeleton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ListItemSkeleton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeaderSkeleton
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.EventRailCard
import kotlinx.datetime.toLocalDateTime
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.NewsCard
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ActivityTicker
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.ActivityTickerEntry
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.SectionHeader
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.StatusBarScrim
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.avatarColorFor
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.AppTheme
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.fontFamilyFor
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.WindowWidthClass
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.theme.windowWidthClassFor
import diana.soleil.design.iraniancanadienbazzar.core.model.Business
import diana.soleil.design.iraniancanadienbazzar.core.model.categoryIconKey
import diana.soleil.design.iraniancanadienbazzar.core.model.Country
import diana.soleil.design.iraniancanadienbazzar.core.model.DistanceUnit
import diana.soleil.design.iraniancanadienbazzar.core.model.GeoPoint
import diana.soleil.design.iraniancanadienbazzar.core.model.Metros
import diana.soleil.design.iraniancanadienbazzar.core.model.distanceKmFrom
import diana.soleil.design.iraniancanadienbazzar.core.model.formatDistance
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.Res
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_all_canada
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_all_usa
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_country_ca
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_country_us
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_badge_new
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_choose_city
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_coming_soon
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_empty_desc
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_empty_title
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_error
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_retry
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_action_map
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_action_see_all
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_distance_km
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_distance_m
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_distance_mi
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_distance_ft
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_favorite_a11y
import diana.soleil.design.iraniancanadienbazzar.core.model.Language
import diana.soleil.design.iraniancanadienbazzar.core.model.cityLabel
import diana.soleil.design.iraniancanadienbazzar.core.model.localizeDigits
import diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.AppBottomSheet
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_language_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_language_title
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_messages_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_notifications_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.notifications_unread_count_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_search_placeholder
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_gems_card_desc
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_gems_card_title
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_categories
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_ticker_deal
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_ticker_news
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_ticker_person
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_featured
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_for_you
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_gems
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_explore
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_explore_people
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_events
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_months
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_event_pm
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_event_am
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_event_date_format
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_event_free
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_event_image_a11y
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_event_venue_format
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_events_card_title
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_events_card_desc
import androidx.compose.ui.draw.clip
import androidx.compose.ui.text.style.TextOverflow
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_people
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_people_card_desc
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_people_card_title
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_people_see_all
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_deals
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_news
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_section_popular
import diana.soleil.design.iraniancanadienbazzar.feature.home.resources.home_sponsored
import org.jetbrains.compose.resources.stringResource

/**
 * Home / Discover — Stitch `fac255ec` (Directory & Community System). Tokens + string resources only.
 * Stateless; driven by [HomeUiState] (categories/featured/popular from the repositories via the route).
 */
@OptIn(ExperimentalLayoutApi::class)
@Composable
fun HomeScreen(
    state: HomeUiState,
    activeMetroId: String?,
    onSelectMetro: (String?) -> Unit,
    onSelectCountry: (Country) -> Unit,
    onSearch: () -> Unit,
    onOpenMap: () -> Unit,
    onNotifications: () -> Unit,
    onOpenPeople: () -> Unit = {},
    /** Header action on the People rail — the people map (each member picks Hidden / City / Neighbourhood). */
    onOpenPeopleMap: () -> Unit = {},
    /** Header action on the People rail — opens the neighbourhood map. */
    onOpenPerson: (uid: String) -> Unit = {},
    currentLanguage: Language = Language.Default,
    onSelectLanguage: (Language) -> Unit = {},
    onOpenMessages: (() -> Unit)? = null,
    onSeeAllCategories: () -> Unit,
    onCategoryClick: (categoryId: String) -> Unit,
    onBusinessClick: (String) -> Unit,
    onNewsClick: (articleId: String) -> Unit,
    /** "See all" on the Community News rail — the full news list (QA 2026-09-12 #6). */
    onSeeAllNews: () -> Unit = {},
    onToggleFavorite: (String) -> Unit,
    onRetry: () -> Unit,
    modifier: Modifier = Modifier,
    unreadCount: Int = 0,
    userLocation: GeoPoint? = null,
    favorites: Set<String> = emptySet(),
    /** Hidden Gems entry rail — hidden while `feature_hiddengems_enabled` is off. */
    gemsEnabled: Boolean = false,
    onOpenGems: () -> Unit = {},
    /** Events entry card — Events left the bottom nav, so Home is its primary entry point. */
    eventsEnabled: Boolean = false,
    /** `feature_people_enabled` — gates the Find-your-people rail AND its entry card. */
    peopleEnabled: Boolean = false,
    onOpenEvents: () -> Unit = {},
    /** Tapping a card in the Home events rail. */
    onOpenEventDetail: (eventId: String) -> Unit = {},
    /**
     * `home_dense_sections_enabled`. False (launch default) drops the discretionary rails — For You,
     * People, Deals, News — leaving Categories, Featured, the Events/Gems entries and Popular. Thin
     * rails read as an empty app at launch density; the owner flips this on when there's volume.
     */
    denseSections: Boolean = false,
) {
    if (state.error) {
        ErrorState(
            message = stringResource(Res.string.home_error),
            onRetry = onRetry,
            retryLabel = stringResource(Res.string.home_retry),
            modifier = modifier,
        )
        return
    }
    val lang = AppTheme.language
    BoxWithConstraints(
        modifier = modifier.fillMaxSize().background(AppTheme.colors.background),
    ) {
        val widthClass = windowWidthClassFor(maxWidth)
        val contentModifier = if (widthClass == WindowWidthClass.Compact) {
            Modifier.fillMaxWidth()
        } else {
            Modifier.widthIn(max = AppTheme.sizes.contentMaxWidth).fillMaxWidth()
        }
    // Scroll-reactive status bar (owner direction 2026-07-12): the band paints BEHIND the status
    // bar (dark green + light icons); once the band scrolls past it, an animated surface scrim +
    // dark icons take over. `scrolled` flips exactly when the band's bottom passes the inset.
    val scrollState = rememberScrollState()
    var bandHeightPx by remember { mutableStateOf(0) }
    val statusInsetPx = WindowInsets.statusBars.getTop(LocalDensity.current)
    val scrolled = bandHeightPx > 0 &&
        scrollState.value >= (bandHeightPx - statusInsetPx).coerceAtLeast(0)
    Column(
        modifier = Modifier
            .fillMaxSize()
            .verticalScroll(scrollState),
        horizontalAlignment = Alignment.CenterHorizontally,
        // Negative gap: the content sheet's rounded top corners overlap the band's bottom strip.
        verticalArrangement = Arrangement.spacedBy(-AppTheme.spacing.xl),
    ) {
        // ── Header band: a brand-colored block owning location, notifications, and the search
        // pill. Search is the hero action, permanently visible on Home (Gooya-style chrome —
        // owner direction 2026-07-11; supersedes the Stitch fac255ec top bar).
        // "All <country>" + the metros of the active country only (never mix CA and US in one list).
        val allCountryLabel = when (state.activeCountry) {
            Country.US -> stringResource(Res.string.home_all_usa)
            Country.CA -> stringResource(Res.string.home_all_canada)
        }
        val cityOptions = listOf(CityOption(null, allCountryLabel)) +
            Metros.forCountry(state.activeCountry).map { metro ->
                CityOption(
                    id = metro.id,
                    label = metro.name.resolve(lang),
                    enabled = metro.id in state.launchedMetros,
                )
            }
        val selectedLabel = cityOptions.firstOrNull { it.id == activeMetroId }?.label ?: allCountryLabel
        Column(
            modifier = Modifier
                .fillMaxWidth()
                .background(AppTheme.colors.brandBand)
                .onSizeChanged { bandHeightPx = it.height },
            horizontalAlignment = Alignment.CenterHorizontally,
        ) {
            Column(
                modifier = contentModifier
                    .statusBarsPadding()
                    .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.md),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                HeaderRow(
                    cityOptions = cityOptions,
                    selectedMetroId = activeMetroId,
                    selectedLabel = selectedLabel,
                    onSelectMetro = onSelectMetro,
                    activeCountry = state.activeCountry,
                    onSelectCountry = onSelectCountry,
                    availableCountries = Metros.launchedCountries(state.launchedMetros),
                    sheetTitle = stringResource(Res.string.home_choose_city),
                    comingSoonLabel = stringResource(Res.string.home_coming_soon),
                    onNotifications = onNotifications,
                    unreadCount = unreadCount,
                    // Expanded layouts already carry a bell (with badge) in the top nav bar —
                    // showing this one too put two bells on screen on the web.
                    showNotifications = widthClass != WindowWidthClass.Expanded,
                    currentLanguage = currentLanguage,
                    onSelectLanguage = onSelectLanguage,
                    onOpenMessages = onOpenMessages,
                )
                // Home's search bar is a button into the dedicated Search screen (a clickable overlay
                // sits over the display-only field so a tap anywhere — including the tune icon —
                // opens search-with-filters).
                Box {
                    AppSearchBar(
                        value = "",
                        onValueChange = {},
                        placeholder = stringResource(Res.string.home_search_placeholder),
                        leading = { AppIcon("search", tint = AppTheme.colors.onSurfaceVariant) },
                        trailing = { AppIcon("tune", tint = AppTheme.colors.primary) },
                    )
                    Box(
                        modifier = Modifier
                            .matchParentSize()
                            .clickable(onClick = onSearch),
                    )
                }
            }
            // Teal strip the content sheet's rounded corners overlap (matches the negative gap).
            Spacer(modifier = Modifier.height(AppTheme.spacing.xl))
        }
      Column(
        // The content "sheet": full-width, rounded top corners sliding under the band
        // (owner screenshot direction 2026-07-12). The corners are a SHAPED BACKGROUND, deliberately
        // NOT `.clip(...)`: clipping puts the whole sheet in a clipped graphics layer, and Android
        // pointer hit-testing inside such a layer fails beyond ~10k px (~4000dp) from the layer's
        // top — every business row past that point silently stopped being clickable/likeable.
        // Content is padded away from the top corners, so the shape alone renders identically.
        modifier = Modifier
            .fillMaxWidth()
            .background(AppTheme.colors.background, AppTheme.shapes.sheetTop),
        horizontalAlignment = Alignment.CenterHorizontally,
      ) {
      Column(
        modifier = contentModifier
            .padding(
                start = AppTheme.spacing.lg,
                end = AppTheme.spacing.lg,
                top = AppTheme.spacing.md,
                // Clear the bottom nav bar + floating Post button so the last "Popular near you"
                // items are fully scrollable and tappable (fixes items trapped under the bar).
                bottom = AppTheme.sizes.bottomBarContentClearance,
            ),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xl),
      ) {
        val gridColumns = when (widthClass) {
            WindowWidthClass.Compact -> 4
            WindowWidthClass.Medium -> 6
            WindowWidthClass.Expanded -> 8
        }
        if (state.loading) {
            // Shimmer skeletons mirroring the real sections — no headers over empty space while
            // the first load is in flight (the "titles floating on nothing" feel).
            HomeSkeleton(gridColumns = gridColumns, widthClass = widthClass)
        } else {
        // Activity ticker — thin rotating "what's happening" strip. Privacy-safe by construction:
        // every line derives from the public streams Home already shows (deals/people/news).
        if (state.ticker.isNotEmpty()) {
            ActivityTicker(
                entries = state.ticker.map { item ->
                    when (item) {
                        is TickerItem.DealPosted -> ActivityTickerEntry(
                            iconName = "sell",
                            text = stringResource(
                                Res.string.home_ticker_deal, item.businessName, item.title.resolve(lang),
                            ),
                        )
                        is TickerItem.PersonJoined -> ActivityTickerEntry(
                            iconName = "person_add",
                            text = stringResource(Res.string.home_ticker_person, item.firstName),
                        )
                        is TickerItem.NewsPublished -> ActivityTickerEntry(
                            iconName = "newspaper",
                            text = stringResource(Res.string.home_ticker_news, item.title.resolve(lang)),
                        )
                    }
                },
            )
        }
        // Featured — monetized placements lead, directly under the category grid. The whole
        // section (header included) hides when there is nothing featured.
        if (state.featured.isNotEmpty()) {
        Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
            // Map view ships as a real feature later — no dead affordance until it exists.
            SectionHeader(title = stringResource(Res.string.home_section_featured))
            val sponsoredLabel = stringResource(Res.string.home_sponsored)
            val newLabel = stringResource(Res.string.home_badge_new)
            val featuredCard: @Composable (Business) -> Unit = { business ->
                val coverUrl = business.coverUrl?.takeIf { it.isNotBlank() }
                val icon = categoryIconKey(business.categoryId)
                val imageRes = categoryImageRes(business.categoryId)
                FeaturedBusinessCard(
                    name = business.displayName(lang),
                    subtitle = business.serviceLine(lang),
                    rating = business.rating.toFloat(),
                    newLabel = newLabel.takeIf { business.reviewCount == 0 },
                    city = AppTheme.language.cityLabel(business.address.city),
                    onClick = { onBusinessClick(business.id) },
                    sponsoredLabel = if (business.sponsorship.active) sponsoredLabel else null,
                    coverIcon = icon,
                    coverImageRes = imageRes,
                    image = coverUrl?.let { url -> { BusinessCover(imageUrl = url, iconName = icon, placeholderImageRes = imageRes) } },
                )
            }
            // Compact: a horizontal carousel. Wider: cards wrap into a grid (fixed card width).
            if (widthClass == WindowWidthClass.Compact) {
                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                    contentPadding = PaddingValues(end = AppTheme.spacing.lg),
                ) {
                    items(state.featured, key = { it.id }) { featuredCard(it) }
                }
            } else {
                FlowRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                ) {
                    state.featured.forEach { featuredCard(it) }
                }
            }
        }
        }

        // Events — a real rail of upcoming events, not just a link. Events is the acquisition wedge
        // (docs/ACTION_PLAN.md Track F) and it is time-sensitive, so it sits directly under Featured
        // and ahead of News. Additive: hides entirely when empty / flag off.
        if (state.events.isNotEmpty()) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                SectionHeader(
                    title = stringResource(Res.string.home_section_events),
                    actionLabel = stringResource(Res.string.home_action_see_all),
                    onAction = onOpenEvents,
                )
                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                    contentPadding = PaddingValues(end = AppTheme.spacing.lg),
                ) {
                    items(state.events, key = { it.id }) { event ->
                        val eventTitle = event.title.resolve(lang)
                        EventRailCard(
                            title = eventTitle,
                            dateTime = homeEventDateTime(event.startsAtMillis),
                            // Seeded events sometimes carry an empty venue name or city; joining the
                            // non-blank parts avoids rendering a bare ", " next to the pin icon.
                            venue = listOf(event.venue.name, AppTheme.language.cityLabel(event.venue.city))
                                .filter { it.isNotBlank() }
                                .joinToString(", "),
                            imageContentDescription = stringResource(Res.string.home_event_image_a11y, eventTitle),
                            onClick = { onOpenEventDetail(event.id) },
                            coverUrl = event.coverUrl,
                            badgeLabel = stringResource(Res.string.home_event_free).takeIf { event.isFree },
                            // Without an explicit width the card fills the row and only one is visible.
                            modifier = Modifier.width(AppTheme.sizes.eventRailCardWidth),
                        )
                    }
                }
            }
        }


        // Community news — admin-published stories; the whole section hides when there are none.
        if (state.news.isNotEmpty()) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                SectionHeader(
                    title = stringResource(Res.string.home_section_news),
                    actionLabel = stringResource(Res.string.home_action_see_all),
                    onAction = onSeeAllNews,
                )
                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                    contentPadding = PaddingValues(end = AppTheme.spacing.lg),
                ) {
                    items(state.news, key = { it.id }) { article ->
                        NewsCard(
                            title = article.title.resolve(lang),
                            teaser = article.summary.resolve(lang).ifBlank { article.body.resolve(lang) },
                            imageUrl = article.imageUrl,
                            onClick = { onNewsClick(article.id) },
                        )
                    }
                }
            }
        }

        // For you — personalized rail of businesses matching the interests picked in onboarding /
        // Profile. Hides entirely when the user chose no interests or nothing matches.
        if (denseSections && state.forYou.isNotEmpty()) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                SectionHeader(title = stringResource(Res.string.home_section_for_you))
                val sponsoredLabel = stringResource(Res.string.home_sponsored)
                val newLabel = stringResource(Res.string.home_badge_new)
                val forYouCard: @Composable (Business) -> Unit = { business ->
                    val coverUrl = business.coverUrl?.takeIf { it.isNotBlank() }
                    val icon = categoryIconKey(business.categoryId)
                    val imageRes = categoryImageRes(business.categoryId)
                    FeaturedBusinessCard(
                        name = business.displayName(lang),
                        subtitle = business.serviceLine(lang),
                        rating = business.rating.toFloat(),
                        newLabel = newLabel.takeIf { business.reviewCount == 0 },
                        city = AppTheme.language.cityLabel(business.address.city),
                        onClick = { onBusinessClick(business.id) },
                        sponsoredLabel = if (business.sponsorship.active) sponsoredLabel else null,
                        coverIcon = icon,
                        coverImageRes = imageRes,
                        image = coverUrl?.let { url -> { BusinessCover(imageUrl = url, iconName = icon, placeholderImageRes = imageRes) } },
                    )
                }
                if (widthClass == WindowWidthClass.Compact) {
                    LazyRow(
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                        contentPadding = PaddingValues(end = AppTheme.spacing.lg),
                    ) {
                        items(state.forYou, key = { it.id }) { forYouCard(it) }
                    }
                } else {
                    FlowRow(
                        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                    ) {
                        state.forYou.forEach { forYouCard(it) }
                    }
                }
            }
        }

        // Merchant deals — live promotions rail (soonest-ending first); hides when none / flag off.
        if (denseSections && state.deals.isNotEmpty()) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                SectionHeader(title = stringResource(Res.string.home_section_deals))
                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                    contentPadding = PaddingValues(end = AppTheme.spacing.lg),
                ) {
                    items(state.deals, key = { it.id }) { deal ->
                        DealCard(deal = deal, lang = lang, onClick = { onBusinessClick(deal.businessId) })
                    }
                }
            }
        }

        // People near you — a real rail, no longer density-gated (owner direction 2026-08-02).
        // The header action is the MAP rather than "See all", matching how "Popular near you"
        // already works; the Explore tile below is the way into the People LIST, and it only
        // appears when this rail is empty so the feature can never be orphaned again.
        if (peopleEnabled && state.people.isNotEmpty()) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                // People map: members appear only via a manual 4-hour check-in at an approximate
                // city/neighbourhood area — never a precise position, never a standing setting.
                SectionHeader(
                    title = stringResource(Res.string.home_section_people),
                    actionLabel = stringResource(Res.string.home_action_map),
                    onAction = onOpenPeopleMap,
                )
                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                    contentPadding = PaddingValues(end = AppTheme.spacing.lg),
                ) {
                    items(state.people, key = { it.uid }) { person ->
                        PersonBubble(person = person, onClick = { onOpenPerson(person.uid) })
                    }
                }
            }
        }

        // Explore — compact entries for the features that have no rail of their own.
        //
        // These were three consecutive full-width teal banners, each with its own near-duplicate
        // section header — ~46% of the visible screen for three tap targets, pushing the actual
        // businesses below the fold (owner, 2026-08-02). Reusing `CategoryTile` keeps them in the
        // grid language Home already speaks instead of inventing a fourth card style, and sits them
        // next to Categories because both are navigation.
        //
        // Events left this row on 2026-08-02 when it got a real rail above; each remaining tile is
        // still independently flag-gated, so the row shrinks and disappears cleanly.
        run {
            // Hidden Gems is now a FULL-WIDTH button (owner, 2026-09-16): the small square tile read
            // as a minor category, while Gems is a whole world of content. Same height as the tile
            // row it replaced, with the illustrated art instead of the flat "diamond" glyph.
            val peopleFallback = peopleEnabled && state.people.isEmpty()
            if (gemsEnabled || peopleFallback) {
                Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                    SectionHeader(title = stringResource(Res.string.home_section_explore))
                    if (gemsEnabled) {
                        AppCard(modifier = Modifier.fillMaxWidth(), onClick = onOpenGems) {
                            Row(
                                modifier = Modifier.fillMaxWidth().padding(AppTheme.spacing.md),
                                verticalAlignment = Alignment.CenterVertically,
                                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                            ) {
                                Image(
                                    painter = painterResource(gemArtImage(GemArt.Hub)),
                                    contentDescription = null,
                                    modifier = Modifier.size(AppTheme.sizes.brandMark),
                                )
                                Column(
                                    modifier = Modifier.weight(1f),
                                    verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
                                ) {
                                    Text(
                                        text = stringResource(Res.string.home_section_gems),
                                        style = AppTheme.typography.bodyLg,
                                        color = AppTheme.colors.onSurface,
                                    )
                                    Text(
                                        text = stringResource(Res.string.home_gems_card_desc),
                                        style = AppTheme.typography.bodySm,
                                        color = AppTheme.colors.onSurfaceVariant,
                                    )
                                }
                            }
                        }
                    }
                    // Fallback entry: only when the People rail above isn't showing. Keeps the tile
                    // form — it's a rare state and not the section's headline.
                    if (peopleFallback) {
                        FlowRow(
                            modifier = Modifier.fillMaxWidth(),
                            maxItemsInEachRow = gridColumns,
                            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
                            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                        ) {
                            Box(modifier = Modifier.weight(1f), contentAlignment = Alignment.TopCenter) {
                                CategoryTile(
                                    label = stringResource(Res.string.home_explore_people),
                                    iconName = "group",
                                    containerColor = AppTheme.colors.primaryContainer,
                                    contentColor = AppTheme.colors.onPrimary,
                                    onClick = onOpenPeople,
                                )
                            }
                            repeat((gridColumns - 1).coerceAtLeast(0)) {
                                Box(modifier = Modifier.weight(1f)) {}
                            }
                        }
                    }
                }
            }
        }

        // Categories — a compact, horizontally scrollable row rather than the old 3-row tile GRID.
        // Owner direction 2026-08-02: get the categories off the top of Home so real content leads,
        // but keep them obvious and one tap away. ~420dp -> ~110dp; "See All" opens the full grid.
        if (state.categoryShortcuts.isNotEmpty()) {
            Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
                SectionHeader(
                    title = stringResource(Res.string.home_section_categories),
                    actionLabel = stringResource(Res.string.home_action_see_all),
                    onAction = onSeeAllCategories,
                )
                LazyRow(
                    horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
                    contentPadding = PaddingValues(end = AppTheme.spacing.lg),
                ) {
                    items(state.categoryShortcuts, key = { it.id }) { category ->
                        val imageRes = categoryImageRes(category.id)
                        val index = state.categoryShortcuts.indexOf(category)
                        val (container, content) = if (imageRes != null) {
                            AppTheme.colors.surfaceContainerHigh to AppTheme.colors.onSurfaceVariant
                        } else {
                            toneForIndex(index).colors()
                        }
                        Box(modifier = Modifier.width(AppTheme.sizes.homeCategoryTile)) {
                            CategoryTile(
                                label = category.displayName(lang),
                                iconName = category.iconKey,
                                containerColor = container,
                                contentColor = content,
                                onClick = { onCategoryClick(category.id) },
                                imageRes = imageRes,
                            )
                        }
                    }
                }
            }
        }

        // Popular near you — single column on phones, multi-column grid on wider screens.
        if (state.popular.isNotEmpty()) {
        Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
            SectionHeader(
                title = stringResource(Res.string.home_section_popular),
                actionLabel = stringResource(Res.string.home_action_map),
                onAction = onOpenMap,
            )
            val columns = when (widthClass) {
                WindowWidthClass.Compact -> 1
                WindowWidthClass.Medium -> 2
                WindowWidthClass.Expanded -> 3
            }
            val favoriteLabel = stringResource(Res.string.home_favorite_a11y)
            val newBadge = stringResource(Res.string.home_badge_new)
            FlowRow(
                maxItemsInEachRow = columns,
                horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
                verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md),
            ) {
                state.popular.forEach { business ->
                    val coverUrl = business.coverUrl?.takeIf { it.isNotBlank() }
                    val icon = categoryIconKey(business.categoryId)
                    val imageRes = categoryImageRes(business.categoryId)
                    Box(modifier = Modifier.weight(1f)) {
                        BusinessListItem(
                            name = business.displayName(lang),
                            category = business.serviceLine(lang),
                            rating = business.rating.toFloat(),
                            newLabel = newBadge.takeIf { business.reviewCount == 0 },
                            distance = popularDistanceLabel(business, userLocation),
                            favorite = business.id in favorites,
                            onClick = { onBusinessClick(business.id) },
                            onFavoriteClick = { onToggleFavorite(business.id) },
                            favoriteContentDescription = favoriteLabel,
                            coverIcon = icon,
                            coverImageRes = imageRes,
                            thumbnail = coverUrl?.let { url -> { BusinessCover(imageUrl = url, iconName = icon, placeholderImageRes = imageRes) } },
                        )
                    }
                }
            }
        }
        }

        // Nothing at all (fresh region / backend returned empty): a friendly explanation instead
        // of a page of orphaned headers.
        if (state.categoryShortcuts.isEmpty() && state.featured.isEmpty() &&
            state.news.isEmpty() && state.popular.isEmpty()
        ) {
            EmptyState(
                title = stringResource(Res.string.home_empty_title),
                description = stringResource(Res.string.home_empty_desc),
                actionLabel = stringResource(Res.string.home_retry),
                onAction = onRetry,
            )
        }
        }
      }
      }
    }
        // Overlay: animated status-bar zone (transparent over the band → surface once scrolled).
        StatusBarScrim(scrolled = scrolled)
    }
}

/**
 * First-load shimmer for Home: mirrors the category grid, featured carousel, and popular list so
 * the page doesn't jump when real data lands. No section headers — skeleton title lines instead.
 */
@Composable
private fun HomeSkeleton(gridColumns: Int, widthClass: WindowWidthClass) {
    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
        SectionHeaderSkeleton()
        FlowRow(
            modifier = Modifier.fillMaxWidth(),
            maxItemsInEachRow = gridColumns,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
            verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg),
        ) {
            repeat(gridColumns * 2) {
                Box(modifier = Modifier.weight(1f), contentAlignment = Alignment.TopCenter) {
                    CategoryTileSkeleton()
                }
            }
        }
    }
    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
        SectionHeaderSkeleton()
        Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.lg)) {
            val cards = if (widthClass == WindowWidthClass.Compact) 2 else 3
            repeat(cards) { FeaturedCardSkeleton() }
        }
    }
    Column(verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.md)) {
        SectionHeaderSkeleton()
        repeat(3) { ListItemSkeleton() }
    }
}

/**
 * Top row of the Home header band: city selector (band-tinted) and a surface-colored circular
 * notification button, both sitting on the primary-colored band.
 */
@Composable
private fun HeaderRow(
    cityOptions: List<CityOption>,
    selectedMetroId: String?,
    selectedLabel: String,
    onSelectMetro: (String?) -> Unit,
    activeCountry: Country,
    onSelectCountry: (Country) -> Unit,
    availableCountries: List<Country>,
    sheetTitle: String,
    comingSoonLabel: String,
    onNotifications: () -> Unit,
    unreadCount: Int,
    showNotifications: Boolean,
    currentLanguage: Language,
    onSelectLanguage: (Language) -> Unit,
    onOpenMessages: (() -> Unit)?,
) {
    var showLanguageSheet by remember { mutableStateOf(false) }
    Row(
        modifier = Modifier.fillMaxWidth(),
        horizontalArrangement = Arrangement.SpaceBetween,
        verticalAlignment = Alignment.CenterVertically,
    ) {
        CitySelector(
            selectedLabel = selectedLabel,
            options = cityOptions,
            selectedId = selectedMetroId,
            onSelect = onSelectMetro,
            sheetTitle = sheetTitle,
            comingSoonLabel = comingSoonLabel,
            contentColor = AppTheme.colors.onPrimary,
            // Country toggle pinned above the metro list — switching re-scopes the list live (the
            // sheet stays open; picking a metro is what closes it).
            header = {
                CountryToggle(activeCountry = activeCountry, onSelectCountry = onSelectCountry, availableCountries = availableCountries)
            },
        )
        if (showNotifications) Row(horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm)) {
            HeaderIconButton(
                iconName = "translate",
                contentDescription = stringResource(Res.string.home_language_a11y),
                onClick = { showLanguageSheet = true },
            )
            if (onOpenMessages != null) {
                HeaderIconButton(
                    iconName = "chat",
                    contentDescription = stringResource(Res.string.home_messages_a11y),
                    onClick = onOpenMessages,
                )
            }
            Box(contentAlignment = Alignment.TopEnd) {
            Box(
                modifier = Modifier
                    .size(AppTheme.sizes.avatarMd)
                    .background(AppTheme.colors.surface, AppTheme.shapes.pill)
                    .clickable(onClick = onNotifications),
                contentAlignment = Alignment.Center,
            ) {
                AppIcon(
                    "notifications",
                    size = AppTheme.sizes.iconMd,
                    tint = AppTheme.colors.onSurface,
                    contentDescription = stringResource(Res.string.home_notifications_a11y),
                )
            }
                NotificationBadge(
                    count = unreadCount,
                    contentDescription = stringResource(Res.string.notifications_unread_count_a11y, unreadCount),
                )
            }
        }
    }
    if (showLanguageSheet) {
        AppBottomSheet(
            onDismissRequest = { showLanguageSheet = false },
            title = stringResource(Res.string.home_language_title),
        ) {
            Language.entries.forEach { language ->
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .clickable {
                            onSelectLanguage(language)
                            showLanguageSheet = false
                        }
                        .padding(vertical = AppTheme.spacing.md, horizontal = AppTheme.spacing.sm),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Text(
                        // Endonyms are conventionally shown untranslated; each renders in ITS OWN
                        // script's font (the active-locale font lacks Arabic glyphs → tofu فارسی).
                        text = language.endonym,
                        style = AppTheme.typography.bodyLg.copy(fontFamily = fontFamilyFor(language)),
                        color = AppTheme.colors.onSurface,
                        modifier = Modifier.weight(1f),
                    )
                    if (language == currentLanguage) {
                        AppIcon("check", size = AppTheme.sizes.iconMd, tint = AppTheme.colors.primary)
                    }
                }
            }
        }
    }
}

/** White circular header action on the brand band (same treatment as the bell). */
@Composable
private fun HeaderIconButton(iconName: String, contentDescription: String, onClick: () -> Unit) {
    Box(
        modifier = Modifier
            .size(AppTheme.sizes.avatarMd)
            .background(AppTheme.colors.surface, AppTheme.shapes.pill)
            .clickable(onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        AppIcon(iconName, size = AppTheme.sizes.iconMd, tint = AppTheme.colors.onSurface, contentDescription = contentDescription)
    }
}

/**
 * Two-chip country toggle for the city sheet (docs/US_EXPANSION_PLAN.md). Tapping a country calls
 * [onSelectCountry], which re-scopes the metro list below without closing the sheet. Labels carry the
 * flag emoji and are localized by the caller.
 */
@Composable
private fun CountryToggle(
    activeCountry: Country,
    onSelectCountry: (Country) -> Unit,
    availableCountries: List<Country>,
) {
    // Only one country live (e.g. CA-only launch) → no toggle at all; the label reads plainly.
    if (availableCountries.size < 2) return
    val labels = mapOf(
        Country.CA to stringResource(Res.string.home_country_ca),
        Country.US to stringResource(Res.string.home_country_us),
    )
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(horizontal = AppTheme.spacing.lg, vertical = AppTheme.spacing.sm),
        horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.sm),
    ) {
        availableCountries.forEach { country ->
            AppChip(
                label = labels[country] ?: country.code,
                selected = country == activeCountry,
                onClick = { if (country != activeCountry) onSelectCountry(country) },
            )
        }
    }
}

/**
 * Hidden Gems entry card: brand-tinted treasure-box invitation into `/gems` (a full-width card —
 * the hub itself is the destination, so no per-item preview here).
 */



/** Visual tones cycled across the category shortcuts (a presentation concern, not data). */
private enum class CategoryTone { Primary, Secondary, Tertiary, Neutral }

private fun toneForIndex(index: Int): CategoryTone =
    CategoryTone.entries[index % CategoryTone.entries.size]

@Composable
private fun CategoryTone.colors(): Pair<Color, Color> = when (this) {
    CategoryTone.Primary -> AppTheme.colors.primaryContainer to AppTheme.colors.onPrimaryContainer
    CategoryTone.Secondary -> AppTheme.colors.secondaryContainer to AppTheme.colors.onSecondaryContainer
    CategoryTone.Tertiary -> AppTheme.colors.tertiary to AppTheme.colors.onTertiary
    CategoryTone.Neutral -> AppTheme.colors.surfaceContainerHigh to AppTheme.colors.onSurfaceVariant
}

/**
 * "Popular near you" secondary line (Stitch shows distance here). Prefers "1.2 km away" once the user's
 * location is known and the business is geocoded; falls back to the business city otherwise — including
 * when the device is nowhere near the browsed metro ("3,630 km away" is noise, the city is the signal).
 */
@Composable
private fun popularDistanceLabel(business: Business, userLocation: GeoPoint?): String {
    val km = userLocation?.let { business.distanceKmFrom(it) }
    return if (km != null && km <= PLAUSIBLE_DISTANCE_KM) {
        // Unit follows the business's own country (km for CA, miles for US) — docs/US_EXPANSION_PLAN.md §4.
        distanceLabel(km, Country.fromCode(business.address.country) ?: Country.CA)
    } else {
        AppTheme.language.cityLabel(business.address.city)
    }
}

/** Beyond this the user clearly isn't browsing "near" the business — show its city instead. */
private const val PLAUSIBLE_DISTANCE_KM = 100.0

/** "2.4 km away" / "1.5 mi away", localized. Sub-coarse distances read in metres (CA) or feet (US). */
@Composable
private fun distanceLabel(km: Double, country: Country): String {
    val display = formatDistance(km, country) // core/model formatter → value + unit
    return when (display.unit) {
        DistanceUnit.KM -> stringResource(Res.string.home_distance_km, display.value)
        DistanceUnit.METRE -> stringResource(Res.string.home_distance_m, display.value)
        DistanceUnit.MILE -> stringResource(Res.string.home_distance_mi, display.value)
        DistanceUnit.FOOT -> stringResource(Res.string.home_distance_ft, display.value)
    }
}

/** Gold promo card on the Home deals rail: offer headline + the business it belongs to. */
@Composable
private fun DealCard(
    deal: diana.soleil.design.iraniancanadienbazzar.core.model.Deal,
    lang: diana.soleil.design.iraniancanadienbazzar.core.model.Language,
    onClick: () -> Unit,
) {
    Column(
        modifier = Modifier
            .width(AppTheme.sizes.featuredCardWidth)
            .clip(AppTheme.shapes.card)
            .background(AppTheme.colors.secondaryContainer)
            .clickable(onClick = onClick)
            .padding(AppTheme.spacing.md),
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
    ) {
        Row(
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        ) {
            AppIcon(
                name = "sell",
                size = AppTheme.sizes.iconSm,
                tint = AppTheme.colors.onSecondaryContainer,
            )
            Text(
                text = deal.businessName,
                style = AppTheme.typography.labelSm,
                color = AppTheme.colors.onSecondaryContainer,
                maxLines = 1,
                overflow = TextOverflow.Ellipsis,
            )
        }
        Text(
            text = deal.title.resolve(lang),
            style = AppTheme.typography.labelMd,
            color = AppTheme.colors.onSecondaryContainer,
            maxLines = 2,
            overflow = TextOverflow.Ellipsis,
        )
    }
}

/** Round avatar + first name for the Meet-people rail (photo, or initial on per-identity color). */
@Composable
private fun PersonBubble(
    person: diana.soleil.design.iraniancanadienbazzar.core.model.PublicProfile,
    onClick: () -> Unit,
) {
    Column(
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.spacedBy(AppTheme.spacing.xs),
        modifier = Modifier.clickable(onClick = onClick),
    ) {
        diana.soleil.design.iraniancanadienbazzar.core.designsystem.component.PersonAvatar(
            id = person.uid,
            name = person.displayName,
            photoUrl = person.photoUrl,
            size = AppTheme.sizes.homeCategoryTile,
        )
        Text(
            text = person.displayName.substringBefore(" "),
            style = AppTheme.typography.labelSm,
            color = AppTheme.colors.onSurface,
            maxLines = 1,
            overflow = TextOverflow.Ellipsis,
        )
    }
}

/**
 * "AUG 7 • 8:30 PM" for the Home events rail.
 *
 * Duplicated from `:feature:events` on purpose: a feature module may not depend on another feature
 * module (golden rule 5), and the localized month/AM-PM copy cannot live in `:core:designsystem`
 * because DS components hold no copy (golden rule 6). Tracked in docs/PENDING.md as a dedupe
 * candidate if a shared i18n-capable module ever appears.
 */
@Composable
private fun homeEventDateTime(epochMillis: Long): String {
    val value = kotlin.time.Instant.fromEpochMilliseconds(epochMillis)
        .toLocalDateTime(kotlinx.datetime.TimeZone.currentSystemDefault())
    val hour12 = when {
        value.hour == 0 -> 12
        value.hour > 12 -> value.hour - 12
        else -> value.hour
    }
    val months = org.jetbrains.compose.resources.stringArrayResource(Res.array.home_months)
    // Persian digits in Farsi: resource args always render Western digits (see NumberFormatting).
    return AppTheme.language.localizeDigits(
        stringResource(
            Res.string.home_event_date_format,
            months.getOrNull(value.month.ordinal) ?: "",
            value.day,
            hour12,
            value.minute.toString().padStart(2, '0'),
            stringResource(if (value.hour < 12) Res.string.home_event_am else Res.string.home_event_pm),
        ),
    )
}
